import React, { useState } from "react";
import { createRoot } from "react-dom/client";

function PracticalFacts({ item }) {
  return <div className="react-practical">
    <dl className="practical-facts">{(item.practical || []).map((fact) =>
      <div key={fact.label}><dt>{fact.label}</dt><dd>{fact.value}</dd></div>
    )}</dl>
    <p className="event-freshness">{item.freshness}</p>
  </div>;
}

function BrowserCard({ item }) {
  return (
    <a className="react-browser-card" href={item.url}>
      <div className="react-browser-date">
        <strong>{item.day_label}</strong>
        <span>{item.date_label}</span>
      </div>
      <div className="react-browser-main">
        {item.category_label ? (
          <span className={`category-tag category-tag-${item.category_tone || "grey"}`}>{item.category_label}</span>
        ) : null}
        <strong>{item.title}</strong>
        <p>{item.time_label}</p>
        <PracticalFacts item={item} />
      </div>
      <div className="react-browser-meta">
        <span>{item.location}</span>
        {item.organisation ? <small>{item.organisation}</small> : null}
        {item.is_recurring ? <span className="badge react-browser-badge">Recurring</span> : null}
      </div>
    </a>
  );
}

function RegularGroup({ group }) {
  return (
    <article className="react-browser-group">
      <h3>{group.day_name}</h3>
      <div className="react-browser-group-list">
        {group.events.map((event) => (
          <a key={event.id} className="react-browser-group-item" href={event.url}>
            <strong>{event.time_label}</strong>
            <div>
              {event.category_label ? (
                <span className={`category-tag category-tag-${event.category_tone || "grey"}`}>{event.category_label}</span>
              ) : null}
              <span className="react-browser-group-title">{event.title}</span>
              <PracticalFacts item={event} />
              <p>
                {event.location}
                {event.organisation ? ` · ${event.organisation}` : ""}
              </p>
            </div>
          </a>
        ))}
      </div>
    </article>
  );
}

function HomeBrowser({ data }) {
  const [activeTab, setActiveTab] = useState(data.tabs[0]?.id ?? "coming-up");
  const currentTab = data.tabs.find((tab) => tab.id === activeTab) ?? data.tabs[0];

  return (
    <div className="react-browser">
      <div className="react-browser-tabs" role="tablist" aria-label="Homepage browser">
        {data.tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={tab.id === activeTab}
            className={`react-browser-tab${tab.id === activeTab ? " is-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <p className="react-browser-description">{currentTab.description}</p>
      {currentTab.items?.length ? (
        <div className="react-browser-list">
          {currentTab.items.map((item) => (
            <BrowserCard key={item.id} item={item} />
          ))}
        </div>
      ) : null}
      {currentTab.groups?.length ? (
        <div className="react-browser-groups">
          {currentTab.groups.map((group) => (
            <RegularGroup key={group.day_name} group={group} />
          ))}
        </div>
      ) : null}
      {!currentTab.items?.length && !currentTab.groups?.length ? (
        <p className="empty-state">Nothing is available for this section yet.</p>
      ) : null}
    </div>
  );
}

const mountNode = document.getElementById("home-react-browser");
const dataNode = document.getElementById("home-react-browser-data");

if (mountNode && dataNode) {
  const payload = JSON.parse(dataNode.textContent || "{}");
  createRoot(mountNode).render(<HomeBrowser data={payload} />);
}
